import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../Styles/PageLoader.css";

function PageLoader() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setLoading(true);
    setVisible(true);

    const timer = setTimeout(() => {
      setLoading(false);
      setTimeout(() => setVisible(false), 400);
    }, 600);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (!visible) return null;

  return (
    <div className={`page-loader${loading ? " is-active" : " is-exit"}`}>
      <div className="pl-content">
        <div className="pl-spinner">
          <svg viewBox="0 0 50 50" className="pl-svg">
            <circle cx="25" cy="25" r="20" className="pl-track" />
            <circle cx="25" cy="25" r="20" className="pl-progress" />
          </svg>
        </div>
        <span className="pl-text">Loading</span>
      </div>
      <div className="pl-bar">
        <div className="pl-bar-fill" />
      </div>
    </div>
  );
}

export default PageLoader;
